/**
 * Moonpage 品牌 - Book 页面配置
 */
import { commonTexts } from './common'
import type { BookPageConfig } from './types'
import { theme as brandTheme } from '@/config/brands'

export const theme = {
  quoteColor: 'rgba(76, 125, 255, 0.22)',
  tocLockColor: brandTheme.primaryColor,
} as const

export const bookConfig: BookPageConfig = {
  theme,
  texts: commonTexts,
}
